/**
 * @file AboutPage.jsx
 * @description About page with information about memorize.life
 */

import React from "react";
import { Icon } from "./Icon";
import { useViewportHeight } from "../utils/viewportUtils";

export const AboutPage = () => {
  const viewportHeight = useViewportHeight();

  return (
    <div style={{
      height: `calc(${viewportHeight} - 64px)`,
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
      <div style={{ 
        textAlign: 'center', 
        padding: '24px 16px 0 16px',
        flexShrink: 0
      }}>
        <h1 style={{ 
          fontSize: 'var(--md-sys-typescale-headline-large-size)',
          fontWeight: 'var(--md-sys-typescale-headline-large-weight)',
          color: 'var(--md-sys-color-on-surface)',
          margin: '0'
        }}>
          About memorize.life
        </h1>
      </div>

      {/* Scrollable Content */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        minHeight: 0,
        padding: '24px 16px'
      }}>
        <div className="container" style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* Content */}
          <div style={{
            backgroundColor: 'var(--md-sys-color-surface-container-low)',
            borderRadius: '16px',
            padding: '24px',
            marginBottom: '24px'
          }}>
            <p style={{ 
              fontSize: '18px',
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '24px',
              color: 'var(--md-sys-color-on-surface-variant)'
            }}>
              Jeremiah 15:16 says, "Your words were found, and I ate them, and your words became to
              me The gladness and joy of my heart, for I am called by your
              name, O Jehovah, God of hosts."
            </p>

            <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
              Reading the Word of God is an essential part of the Christian
              life. It is through the Bible that we not only learn about God and
              His will, but also get to know Him personally. However, it can be
              difficult to read the Bible consistently. Bible Reading Challenges
              are a way to <strong>read</strong> the Bible with others,
              <strong> encourage</strong> one other to read the Bible consistently, and{" "}
              <strong>get email updates</strong> when it is time to read.
            </p>

            <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
              The use of this site is free, and you can create a reading
              challenge for yourself and for others. The goal of this site is to
              encourage seeking Christians and offer access to tools with which
              to get to know the Word. The only data stored is your provided
              account information, and a record of what you have read. See our{" "}
              <a 
                href="/privacy-policy"
                style={{ 
                  color: 'var(--md-sys-color-primary)',
                  textDecoration: 'none'
                }}
              >
                privacy policy
              </a> for more information.
            </p>

            <p style={{ marginBottom: '0', lineHeight: '1.6' }}>
              This site is a work in progress, and we are always looking for
              feedback. We are working on adding additional Bible versions and
              other tools to support learning and understanding the Bible. If
              you have any suggestions or feedback, please contact us at{" "}
              <a 
                href="mailto:mail@memorize.life"
                style={{ 
                  color: 'var(--md-sys-color-primary)',
                  textDecoration: 'none'
                }}
              >
                mail@memorize.life
              </a>.
            </p>
          </div>

          {/* Back to Home */}
          <div style={{ textAlign: 'center', marginTop: '32px', marginBottom: '32px' }}>
            <md-filled-button href="/">
              <Icon name="home" slot="icon" />
              Back to Home
            </md-filled-button>
          </div>
        </div>
      </div>
    </div>
  );
};
